import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MainRoutingModule } from 'app/main/main-routing.module';
import { IconsModule } from 'app/wipperoz-core/icons/icons.module';
import { StartModule } from 'app/wipperoz-core/start/start.module';
import { FeedbackModule } from '../feedback/feedback.module';
import { FooterModule } from '../footer/footer.module';
import { JoinTodayModule } from '../join-today/join-today.module';
import { MainNavbarModule } from '../main-navbar/main-navbar.module';
import { PricingLandingModule } from '../pricing/pricing.module';
import { RecentBlogArticlesModule } from '../recent-blog-articles/recent-blog-articles.module';
import { WipStepsModule } from '../wip-steps/wip-steps.module';
import { WipperozServicesModule } from '../wipperoz-services/wipperoz-services.module';
import { ContentServicingComponent } from './content-servicing.component';

@NgModule({
  declarations: [ContentServicingComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    StartModule,
    MainRoutingModule,
    MainNavbarModule,
    WipStepsModule,
    FooterModule,
    IconsModule,
    RecentBlogArticlesModule,
    WipperozServicesModule,
    FeedbackModule,
    JoinTodayModule,
    PricingLandingModule
  ],
  exports: [ContentServicingComponent]
})
export class ContentServicingModule {}
